import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, LazyLoadEvent, Message, SelectItem } from 'primeng/api';
import { DataTable } from "primeng/components/datatable/datatable";
import { IEvent } from "../../models/inModels/Event";
import { NotificationContentType } from "../../models/inModels/MessageModel";
import { EventsService } from "../../services/events.service";

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent {
	items: IEvent[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	contentId: number;
	contentType: NotificationContentType;
	sendAllDialog = false;
	constructor(
		private service: EventsService,
		private router: Router,
		private confirmationService: ConfirmationService) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
	}

	changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	edit(event: IEvent) {
		console.log(event);
		this.router.navigate(['events/edit', event.Id]);
	}

	sendAllDialogOpen(jobPost: IEvent) {
		this.contentId = jobPost.Id;
		this.contentType = NotificationContentType.Event;
		this.sendAllDialog = true;
	}

	delete(event: IEvent) {
		console.log(event);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete ${event.Name}?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.delete(event.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/events/events.component.ts